import { Fragment } from 'react'

import TopicHeading from '~/MathTopics/components/TopicHeading'
import LearningProducts from '~/MathTopics/components/LearningProducts'
import { MathTopicData, TopicData } from '~/MathTopics/types/math-topic.type'

interface TopicDetailProps {
  mathTopicData: MathTopicData
}

export default function TopicDetails(props: TopicDetailProps): React.ReactElement {
  const { mathTopicData } = props

  return (
    <>
      {mathTopicData &&
        Object.entries(mathTopicData).map(([topicId, topic]: [string, TopicData]) => (
          <Fragment key={`math-topic-details-${topicId}`}>
            <div
              className="mb-14 last:mb-0 border-b border-purple-light-deep last:border-0 pb-8 last:pb-0"
              id={`math-topic-${topicId}`}
            >
              <TopicHeading title={topic.title} topicId={topicId} />
              <LearningProducts topic={topic} topicId={topicId} />
            </div>
          </Fragment>
        ))}
    </>
  )
}
